import Vue from 'vue'
import Vuex from 'vuex'
import {login,logout} from "@/api/login"
import {ACCESS_TOKEN,USER_INFO} from "@/store/mutation-types"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {},
    state: {
        token: '',
        info:{},
        name:''
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_INFO: (state, info) => {
            state.info = info
        },
    },
    actions: {
        Login({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    if (response.code == 200) {
                        const result = response.data
                        Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
                        Vue.ls.set(USER_INFO, result.user, 7 * 24 * 60 * 60 * 1000)
                        commit('SET_TOKEN', result.token)
                        commit('SET_INFO',result.user);
                        resolve(response)
                    } else {
                        resolve(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },

        Logout({ commit, state }) {
            return new Promise((resolve) => {
                let logoutToken = state.token;
                commit('SET_TOKEN', '')
                commit('SET_INFO', {})
                Vue.ls.remove(ACCESS_TOKEN)
                Vue.ls.remove(USER_INFO)
                logout(logoutToken).then((response) => {
                    resolve(response)
                }).catch(() => {
                    resolve()
                })
            })
        },
    }
})
